export const currentLocale = {
  next: "Next",
  back: "Back",
  datePlaceholder: "mm/dd/yyyy",
  step0Title: "Getting Started",
  step1Title: "Collect Information",
  step2Title: "Signer Role",
  step3Title: "Name",
  step4Title: "Instruction Video",
  step5Title: "Read Your Waiver",
  step6Title: "Read Minors Waiver",
  step7Title: "Record Video",
  step8Title: "Review Video",
  step9Title: "Sign Waiver",
  txtInstructions1:
    "To use AWaiver.com to sign a waiver you **must** be over the age of 18 years (born before {{-Date-}}). You may use AWaiver.com to sign on behalf of a minor (under the age of 18 years) if you are the Parent or Court Appointed Legal Guardian.",
  txtInstructions2:
    "If you are a participant and the guardian for other participants, you will need to sign twice. Once for yourself and again for the minor participants.",
  txtInstructions3:
    "Please complete the remaining steps to sign the **{{-WaiverName-}}** waiver for **{{-CompanyName-}}**. \n Hit the **Next** button in the top right hand side of your screen after completing each step.",
  acknowledgeRead:
    "Please acknowledge that you have read the following waiver.",
  download: "Click __here__ to download and view pdf ", //"download",
  guardian: "Guardian",
  recordInstructions:
    "Please follow the provided instructions to complete your recording",
  recordVideo1: "Make sure your camera has a clear view of you.",
  recordVideo2: "Read the statement below.",
  recordVideo3:
    "When you are ready, press the record button and read the statement while facing your camera.",
  recordVideo4: "Press **Stop** when you have finished reading.",
  timeoutAlert: "Recording was becoming too long and was stopped!",
  record: "Record",
  stop: "Stop",
  reviewRecording: "Verify Recording",
  reviewRecording1:
    "Please make sure you can **see your face** and you can **hear your voice** clearly in the video.   \n  If unsatisfied, please select the *Back Button* to go back and re-record.",
  initialDeviceCheck:
    "To sign AWaiver by this link, the device you are using must have a camera and microphone.  Please switch to another device that has a camera and microphone.  If you are on an iPhone or iPad, please switch to the Safari browser.",
  noAudio: "Microphone was not detected",
  noVideo: "Camera was not detected",
  noVideoOrAudio: "Neither audio nor video capabilities were detected",
  accessDenied:
    "Due to your permission settings for this site, access has been denied.  Please update your settings to include {{-Site-}} and try again.",
  close: "Close",
  submit: "Finish",
  enterEmail: "Enter Your Email Address",
  currentFields: "Please fill out the following fields",
  email: "Email",
  enterPhone: "Enter Your Phone Number",
  enterIce: "Enter In Case of Emergency Phone Number",
  enterAddress: "Enter Your Address",
  address: "Address",
  none: "None of the above",
  wait: "Wait",
  startRecording: "Start Recording",
  selectionAlert: "Please select your role **below** and then press **Next**.",
  notFound:
    "The waiver you are trying to sign does not exist or is no longer available.",
  needsUpgrade:
    "**Incompatible Browser**  \n The video component of this application is not supported on your mobile device's browser at this time.",
  ios:
    "**Incompatible Browser**  \n The video component of this application is not supported on your mobile device's browser at this time.  Please try switching to Safari",
  // submit messages
  submitFail: "There was an error submitting the waiver.  Please try again",
  submitSucceeded: "Your waiver has successfully been submitted.",
  submitting:
    "Your waiver is being **submitted**. <br/> **Please wait** until the completed signing message is displayed.",
  clickToPlay: "Click play arrow in the image to watch the instructional video",

  //tim
  isParticipant: "I am signing the waiver for only **Myself**",
  isGuardian:
    "I am signing the waiver as a **Parent of** or **Legal Guardian of** one or more minors",
  isBoth:
    "I am signing the waiver as both: **Myself** and as a **Parent of** or **Legal Guardian** for others",
  step1Heading: "What is Your Role?",
  roleError: "Invalid Role",
  yourName: "Enter your Full Name:",
  yourBirthday: "Enter your Birthday:",
  step8Heading: "Please Sign Below:",
  validate: "Validate",
  validateSignature: "Validate Signature",
  clear: "Clear",
  signatureError: "Incomplete Signature",
  phoneNumberError: "Invalid Phone Number",
  emailError: "Invalid Email Address",
  nameError: "Invalid name - must include first and last name",
  minorNamePlaceHolder: "Minor's Full Name Here",
  namePlaceHolder: "Name Here",
  fullNamePlaceHolder: "Enter Full Name Here",
  andBirthday: "and Birthday",
  addParticipants: "Add More Minors",
  participantListHeading: "Please list the minors that you are signing for:",
  dateOfBirth: "Date of Birth:",
  participantsName: "Minor's Name",
  icePhoneNumberError: "Invalid. These phone numbers cannot be the same.",
  participantsMaxAgeRequirement: "Minors must be under 18 years old.",
  participantsMinAgeRequirement: "Minors cannot be born in the future.",
  guardianMinAgeRequirement:
    "Invalid. Guardians must sign for people under 18 years old.",
  guardianMaxAgeRequirement: "Invalid. Too Old.",
  tooLong: "Too Long.",
  tooShort: "Too Short.",
  required: "Required.",
  nameRequired: "Name is Required.",
  bothNames: "Please Enter First and Last Name.",
  optInHeading: "I agree to receive special events and offerings",
  messagingOptInHeading: "I agree to receive informative texts",
  loading: "Loading...",
  addMinor: "Add Another Minor",
  birthdayRequired: "Minor's Age is Required.",
  incompleteSignature: "Please Complete Your Signature",
  removeAlert: "Please remove all extra spaces to continue",
  yourGuardian: "You are the legal guardian (over 18 years of age)",
  iAm: "I am",
  yourNameIs: "Your Name is",
  imOver18: "and you are over 18 years of age",
  andOver18: "(over 18 years of age)",
  imSigning: "You are signing for the following Minors' Name",
  select: "Select Name Here",
  pressNext: "Please press the **Next** button to continue",
  oneName: "One minor's full name per line, Please.",
  privacy:
    "*Your privacy is important to us. In short, we do not share your information with anyone other than the company for which you are signing this waiver.  The video you record is used for positive identification of you as the signer of this waiver.  You can review our complete privacy statement* __**[here] (https://wp.indexic.net/privacy-policy/).__**"
};
